export default __webpack_public_path__ + "static/media/vip-2.0613d707.webp";